var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.$expKey()} ${_vm.routeClass}`,attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.overlayOpen),expression:"overlayOpen"}],staticClass:"overlay"}),_vm._v(" "),_c('div',{staticClass:"main"},[_c('Nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }